import { useEffect, useState } from "react";
import { format } from "date-fns";
import { Camera, Loader2, MapPin } from "lucide-react";
import { http } from "@/lib/api";

const Photo = ({ url, cfg, id }) => {
  const [src, setSrc] = useState(null);
  const [big, setBig] = useState(false);
  useEffect(() => {
    let obj;
    http.get(url, { ...cfg(), responseType: "blob" }).then(({ data }) => { obj = URL.createObjectURL(data); setSrc(obj); }).catch(() => setSrc(""));
    return () => { if (obj) URL.revokeObjectURL(obj); };
  }, [url, cfg]);
  if (src === null) return <div className="grid h-20 w-20 shrink-0 place-items-center rounded-xl bg-[#1a1a1a]"><Loader2 className="h-4 w-4 animate-spin text-[#A1A1AA]" /></div>;
  if (!src) return null;
  return (
    <button type="button" onClick={() => setBig(!big)} className={`shrink-0 overflow-hidden rounded-xl border border-[#262626] ${big ? "w-full" : "h-20 w-20"}`} data-testid={`delivery-photo-${id}`}>
      <img src={src} alt="Delivery proof" className={big ? "w-full" : "h-full w-full object-cover"} />
    </button>
  );
};

export const DeliveryList = ({ rows, photoUrl, cfg, showEmailed = false, testid }) => {
  if (rows === null) return <Loader2 className="h-5 w-5 animate-spin text-[#FF6A00]" />;
  if (!rows.length) return <p className="text-sm text-[#A1A1AA]" data-testid={`${testid}-empty`}>No deliveries recorded yet.</p>;
  return (
    <ul className="space-y-3" data-testid={testid}>
      {rows.map((d) => (
        <li key={d.delivery_id} className="flex flex-wrap gap-4 rounded-2xl border border-[#262626] bg-[#0c0c0c] p-4" data-testid={`delivery-row-${d.delivery_id}`}>
          {d.has_photo ? <Photo url={photoUrl(d.delivery_id)} cfg={cfg} id={d.delivery_id} /> : <div className="grid h-20 w-20 shrink-0 place-items-center rounded-xl bg-[#141414]"><Camera className="h-5 w-5 text-[#3a3a3a]" /></div>}
          <div className="min-w-0 flex-1 text-sm">
            <p className="font-semibold text-[#F7F5F0]">{format(new Date(`${d.date}T12:00:00`), "EEEE d MMMM yyyy")}</p>
            {d.left_at && <p className="mt-1 flex items-start gap-1.5 text-[#A1A1AA]"><MapPin className="mt-0.5 h-3.5 w-3.5 shrink-0 text-[#FF6A00]" />Left: {d.left_at}</p>}
            {d.note && <p className="mt-1 text-[#A1A1AA]">Note: {d.note}</p>}
            {showEmailed && <p className="mt-1 text-xs text-[#8a8a8a]">{d.emailed ? "Customer emailed" : d.emailed === false ? "No email sent" : "Email status not recorded"}</p>}
          </div>
        </li>
      ))}
    </ul>
  );
};
